import React from "react";

const DobInput = ({
  value,
  onChange,
  invalid = false,
  label = "DOB",
  required = true,
  labelPosition = "left", // "top" | "left"
}) => {
  const isTop = labelPosition === "top";

  return (
    <div
      className={`w-full mb-4 ${
        isTop
          ? "flex flex-col gap-1"
          : "flex items-center space-x-2"
      }`}
    >
      <label
        htmlFor="dob"
        className={`text-base font-medium text-black ${
          isTop ? "" : "w-full md:w-1/4"
        }`}
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>

      <input
        type="text"
        id="dob"
        placeholder="MM/DD/YYYY"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`text-black block w-full px-3 py-2 bg-slate-50 border-0 border-b-2 rounded-md shadow-sm
          ${invalid ? "border-b-red-500" : "border-b-gray-300"}
          focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
        `}
      />
    </div>
  );
};

export default DobInput;
